import { lazy } from "react";

const HomePage = lazy(() => import("./pages/Home"));

export const routes: any = [
    {
        path: "/",
        permission: "home:read",
        element: <HomePage />,
    },
];
